module.exports = __webpack_public_path__ + "fonts/Roboto-BoldItalic.24d270c0.woff";